import React from "react";
import { makeStyles } from "@mui/styles";
import Carousel from "react-material-ui-carousel";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Grid } from "antd"; // Import Grid
import image1 from "../assets/consult.jpg";
import image2 from "../assets/dig.jpg";
import image3 from "../assets/ta2.jpg";
import imageSrc from "../assets/whyus.avif";
import { useMediaQuery } from 'react-responsive';

const { useBreakpoint } = Grid;
const { Title, Paragraph } = Typography;

// ======= Styles =======
const useStyles = makeStyles((theme) => ({
  container: {
    textAlign: "center",
    padding: "20px",
    width: "100%", /* Full width by default */
    maxWidth: "1200px", /* Maximum width */
    margin: "0 auto", /* Center horizontally */
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  section: {
    marginBottom: "40px",
  },
  carousel: {
    margin: "0px auto",
    width: "100%",
  },
  image: {
    width: "100%",
    height: "650px", // Default height for extra-large screens
    objectFit: "cover",
    transition: "transform 0.5s ease-in-out",
    display: "block",
    borderRadius:"32px",
    [theme.breakpoints.down("lg")]: {
      height: "600px",
    },
    [theme.breakpoints.down("md")]: {
      height: "500px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "400px",
    },
  },
  
  missionVisionContainer: {
    height: "80vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  missionVisionSlide: {
    minHeight: "40vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    animation: "fadeInUp 1s ease-in-out",
    padding: "2rem",
  },
  missionVisionTitle: {
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    fontSize: "2.5rem",
    color: "#333",
    marginBottom: "1rem",
  },
  missionVisionQuote: {
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    fontSize: "1.5rem",
    color: "#555",
    fontStyle: "italic",
    maxWidth: "80%",
  },
  servicesCarouselContainer: {
    // Common or "base" styles
    // backdropFilter: "blur(8px)",
    borderBottomWidth: "0px",
    borderColor: "rgba(255, 255, 255, .15)",
    borderStyle: "solid",
    border: "none",
    borderTopWidth: "1px",
    alignContent: "center",
    alignItems: "center",
    backgroundColor: "#ffffff",
    borderRadius: "32px",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flex: "none",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    width: "94%",
    zIndex: 2,
    animation: "fadeInUp 1s ease-in-out",

    // Default (for large screens) - 80vh
    height: "650px",

    [theme.breakpoints.down("lg")]: {
      height: "600px",
    },

    // When the screen is "medium" size (MD) or smaller => 70vh
    [theme.breakpoints.down("md")]: {
      height: "500px",
    },

    // When the screen is "small" size (SM) or smaller => 50vh
    [theme.breakpoints.down("sm")]: {
      height: "400px",
    },
  },

  // ======= Updated Overlay Styles =======
  overlay: {
    position: "absolute",
    bottom: "55%",
    left: "5%",
    backgroundColor: "rgba(0, 0, 0, 0.7)", // Light black transparent
    padding: "60px 30px",
    borderRadius: "15px",
    zIndex: 10,
    backdropFilter: "blur(8px)",
    opacity: 0.8,
    [theme.breakpoints.down("sm")]: {
      bottom: "50%",
      padding: "40px 20px",
      left: "50%",
      transform: "translateX(-50%)",
      width:"98%",
    },
    [theme.breakpoints.down("xs")]: {
      bottom: "65%",
      padding: "30px 15px",
    },
  },
  overlayText: {
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "1.6rem",
    color: "white",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.4rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.2rem",
    },
  },
  buttonOutlined: {
    border: "1px solid white",
    color: "white",
    marginTop: "30px",
    fontSize: "1.1rem",
    "&:hover": {
      backgroundColor: "rgba(224, 223, 223, 0.1)",
      opacity: 0.7,
      border: "1px solid white",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      marginTop: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.9rem",
      marginTop: "15px",
    },
  },
  whyChooseUsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "120px",
    marginBottom: "120px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "60px",
      marginBottom: "60px",
    },
    
  },
  whyChooseUsBox: {
    width: "95%",
    border: "1px solid lightgrey",
    borderRadius: "32px",
    overflow: "hidden",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    height: "650px",
  

    // When the screen is "medium" size (MD) or smaller => 70vh
    [theme.breakpoints.down("md")]: {
      height: "500px",
    },

    // When the screen is "small" size (SM) or smaller => 50vh
    [theme.breakpoints.down("sm")]: {
      height: "400px",
    },
    
  },
  whyChooseUsImage: {
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  whyChooseUsContent: {
    padding: "50px",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    height: "100%",
    flexDirection: "column",
  },
  titleDesktop: {
    marginBottom: "16px",
    fontSize: "2rem",
  },
  titleMobile: {
    marginBottom: "16px",
    fontSize: "1.5rem",
  },
  paragraphDesktop: {
    fontSize: "1.1rem",
    color: "#555",
  },
  paragraphMobile: {
    fontSize: "1rem",
    color: "#555",
  },
}));

// ======= Carousel Data =======
const missionVisionItems = [
  {
    title: "Our Mission",
    quote: `"Innovating with AI, Empowering Your Future."`,
  },
  {
    title: "Our Vision",
    quote: `"To be the leading force in AI innovation, empowering businesses to achieve unparalleled success."`,
  },
];

const servicesCarouselItems = [
  {
    image: image1,
    alt: "Software and AI Services",
    text: "Software and AI Services",
    category: "Software and AI Services",
  },
  {
    image: image2,
    alt: "Digital Marketing Services",
    text: "Digital Marketing Services",
    category: "Digital Marketing Services",
  },
  {
    image: image3,
    alt: "Talent Acquisition Services",
    text: "Talent Acquisition Services",
    category: "Talent Acquisition Services",
  },
];

// ======= Child component: WhyChooseUs =======
const WhyChooseUs = ({ imageSrc }) => {
  const classes = useStyles();
  const screens = useBreakpoint(); // Get current screen size
  const isMobile =useMediaQuery({ maxWidth: 768 }); // Mobile view (extra small screens)
  const showPara =useMediaQuery({ maxWidth: 600 });
  return (
    <div className={classes.whyChooseUsContainer}>
      <div className={classes.whyChooseUsBox}>
        <Row
          gutter={[0, 0]}
          wrap
          style={{
            flexDirection:  "row",
            height: "100%",
          }}
        >
          {/* Image Column - Hidden on Mobile */}
          { !isMobile && (
            <Col span={12} style={{ minHeight: "100%" }}>
              <div
                className={classes.whyChooseUsImage}
                style={{ backgroundImage: `url(${imageSrc})` }}
              />
            </Col>
          )}
          {/* Content Column */}
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            className={classes.whyChooseUsContent}
          >
            <Title
              level={isMobile ? 4 : 2}
              className={isMobile ? classes.titleMobile : classes.titleDesktop}
            >
              Why Choose Us?
            </Title>
            <Paragraph
              className={
                isMobile ? classes.paragraphMobile : classes.paragraphDesktop
              }
            >
              We specialize in AI-driven, clean, and highly optimized solutions
              that maximize efficiency while minimizing costs. Our approach
              leverages advanced artificial intelligence to streamline processes
              and enhance decision-making.
            </Paragraph>
            {!showPara && (
              <Paragraph className={classes.paragraphDesktop}>
                Our highly qualified engineers are committed to precision,
                cost-effectiveness, and timely delivery. We ensure seamless
                execution, innovation, and customer satisfaction in every
                project.
              </Paragraph>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

// ======= Main Component: Body =======
const Body = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleServiceNavigation = (category) => {
    navigate(`/services?category=${category}`);
  };

  return (
    <div className={classes.container}>
      {/* Mission / Vision Carousel */}
      <div className={classes.missionVisionContainer}>
        <Carousel
          className={classes.carousel}
          autoPlay
          animation="fade"
          interval={4000}
          indicators={false}
          navButtonsAlwaysVisible={false}
          stopAutoPlayOnHover={false}
        >
          {missionVisionItems.map((item, index) => (
            <div key={index} className={classes.missionVisionSlide}>
              <h2 className={classes.missionVisionTitle}>{item.title}</h2>
              <blockquote className={classes.missionVisionQuote}>
                {item.quote}
              </blockquote>
            </div>
          ))}
        </Carousel>
      </div>

      {/* Services Carousel */}
      <div
        className={classes.section}
        style={{ display: "flex", justifyContent: "center" ,borderRadius:"32px", border:"none",  }}
      >
        <div className={classes.servicesCarouselContainer}>
          <Carousel
            className={classes.carousel}
            autoPlay
            animation="slide"
            navButtonsAlwaysVisible
            interval={4000}
            stopAutoPlayOnHover={false}
          >
            {servicesCarouselItems.map((item, index) => (
              <div
                key={index}
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "500px",
                  position: "relative",
                }}
              >
                <img
                  src={item.image}
                  alt={item.alt}
                  className={classes.image}
                />
                <div className={classes.overlay}>
                  <div className={classes.overlayText}>{item.text}</div>
                  <Button
                    variant="outlined"
                    color="primary"
                    className={classes.buttonOutlined}
                    onClick={() => handleServiceNavigation(item.category)}
                  >
                    View More
                  </Button>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <WhyChooseUs imageSrc={imageSrc} />

      {/* ContactUs Section (If needed) */}
      {/* <div className={classes.section} style={{ padding: "0 40px" }}>
        <ContactUs />
      </div> */}
    </div>
  );
};

export default Body;
